import * as React from "react";
import { cn } from "../lib/utils";

type Variant = "warning" | "neutral" | "success" | "danger" | "primary";

const variantStyle: Record<Variant, string> = {
  warning: "bg-warning-soft text-warning",
  neutral: "bg-[#f0f0ec] text-ink-subtle",
  success: "bg-success-soft text-success",
  danger: "bg-danger-soft text-danger",
  primary: "bg-primary-soft text-primary",
};

const dotStyle: Record<Variant, string> = {
  warning: "bg-warning",
  neutral: "bg-ink-subtle",
  success: "bg-success",
  danger: "bg-danger",
  primary: "bg-primary",
};

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  variant?: Variant;
  dot?: boolean;
}

export function Badge({
  variant = "neutral",
  dot,
  className,
  children,
  ...props
}: BadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 px-[9px] py-[3px] rounded-pill text-[10px] font-semibold",
        variantStyle[variant],
        className,
      )}
      {...props}
    >
      {dot && (
        <span className={cn("w-1.5 h-1.5 rounded-pill", dotStyle[variant])} />
      )}
      {children}
    </span>
  );
}
